import { useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Select } from "ui/Form/Select";
import { useDebouncedCallback } from "use-debounce";

type Option = {
  value: string;
  label: string;
};

type SelectProps = {
  options: Option[];
  placeholder?: string;
};

const TableSelect = ({ options, placeholder }: SelectProps) => {
  const location = useLocation();
  const history = useHistory();

  const isActive = new URLSearchParams(location.search).get("isActive");

  let defaultValue = "all";
  if (isActive === "true") {
    defaultValue = "active";
  } else if (isActive === "false") {
    defaultValue = "inactive";
  }

  const [selectValue, setSelectValue] = useState(defaultValue);

  const onDebouncedValueChange = useDebouncedCallback((value: string) => {
    const params = new URLSearchParams(location.search);

    if (value === "all") {
      params.delete("isActive");
    } else {
      params.set("isActive", value === "active" ? "true" : "false");
    }

    history.push(`${location.pathname}?${params.toString()}`);
  }, 500);

  const onValueChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectValue(value);
    onDebouncedValueChange(value);
  };

  return (
    <Select
      name="tableSelect"
      label=""
      options={options}
      placeholder={placeholder}
      onChange={onValueChange}
      aria-label="Table Select"
      value={selectValue}
    />
  );
};

export default TableSelect;
